<template>
  <div class="neg-pad">
    <div class="billing-header">
      <div class="level is-mobile header-level">
        <div class="level-left">
          <div class="level-item">
            <h1>Billing</h1>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item mobi-mar-right">
            <tooltip-new :is-click-away="isClickAway" hyper-link="https://intercom.help/hellopeter/en/collections/2645584-hellopeter-plans-and-billing" :question-mark="tooltipQuestion"></tooltip-new>
          </div>
          <div class="level-item mobi-mar-right">
            <a target="_blank" rel="nofollow" class="about" href="https://intercom.help/hellopeter/en/collections/2645584-hellopeter-plans-and-billing">About this feature</a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showSpinner" class="columns">
      <div class="column is-12 is-margin-top-40">
        <p class="has-text-centered">
          <img src="/static/img/ajax-loader.gif" alt="Verifying payment..." />
        </p>
      </div>
    </div>
    <div v-if="!showSpinner" class="columns is-paddingless is-marginless billing-section">
      <div class="column is-paddingless equal-height">
        <div v-if="!show_thank_you_eft && !show_thank_you" class="form-box">
          <p class="has-text-centered bs-head">Checkout</p>
          <p class="bs-copy has-text-centered" v-text="getFrequencyCopy"></p>
          <h6 class="Business-details mar-bot-16">Select&nbsp;payment&nbsp;method</h6>
          <form>
            <div :disabled="is_sending" class="field">
              <div class="control">
                <label class="radio label-filters">
                  <input :disabled="is_sending" type="radio" v-model="form.payment_method" name="payment_method" value="credit_card" />&nbsp;&nbsp;&nbsp;Credit Card
                </label>
              </div>
              <div class="control">
                <label class="radio label-filters">
                  <input :disabled="is_sending" type="radio" v-model="form.payment_method" name="payment_method" value="eft" />&nbsp;&nbsp;&nbsp;EFT
                </label>
              </div>
            </div>
            <h6 class="User-details mar-bot-16" v-html="paymentMethod"></h6>
            <div v-if="isCreditCardPaymentMethod" class="field is-grouped is-grouped-multiline">
              <div class="control">
                <label class="label">Card holder name</label>
                <input :disabled="is_sending" autocomplete="cc-csc" v-model="form.selected_cc_name" class="input" type="text" placeholder="Card holder name" />
                <p class="help is-danger" v-if="form.errors.has('selected_cc_name')" v-text="form.errors.get('selected_cc_name')"></p>
              </div>
              <div class="control">
                <label class="label">Credit card number</label>
                <input :disabled="is_sending" autocomplete="cc-csc" class="input" type="text" v-model="form.selected_cc_number" placeholder="Credit card number" />
                <p class="help is-danger" v-if="form.errors.has('selected_cc_number')" v-text="form.errors.get('selected_cc_number')"></p>
              </div>
            </div>
            <div :disabled="is_sending" v-if="isCreditCardPaymentMethod" class="field is-grouped">
              <div class="control">
                <label class="label">Month</label>
                <custom-drop-down @changed="setCreditCardMonth" btn-min-width="" :credit-card-field="small_credit_card" place-holder="Month" dropdown-name="credit_card_month" :items="months"></custom-drop-down>
              </div>
              <div class="control">
                <label class="label">Year</label>
                <custom-drop-down @changed="setCreditCardYear" btn-min-width="" :credit-card-field="small_credit_card" place-holder="Year" dropdown-name="credit_card_year" :items="years"></custom-drop-down>
              </div>
              <div class="control cc_info">
                <label class="label">CVV</label>
                <input :disabled="is_sending" autocomplete="cc-csc" class="input cc_field" v-model="form.selected_cc_ccv" type="text" placeholder="CVV" /><tooltip-new class="rel-pos" content-width="160px">The last 3 digits at the back of your card</tooltip-new>
              </div>
              <div class="control is-hidden-mobile">
                <label class="label">&nbsp;</label>
                <div class="level is-mobile">
                  <div class="level-right">
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isVisa }]" alt="Visa" srcset="/static/img/creditcard/visa.png, /static/img/creditcard/visa@2x.png 2x, /static/img/creditcard/visa@3x.png 3x" src="/static/img/creditcard/visa.png" />
                    </div>
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isMasterCard }]" alt="Master Card" srcset="/static/img/creditcard/mastercard.png, /static/img/creditcard/mastercard@2x.png 2x, /static/img/creditcard/mastercard@3x.png 3x" src="/static/img/creditcard/mastercard.png" />
                    </div>
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isAmex }]" alt="American Express" srcset="/static/img/creditcard/amex.png, /static/img/creditcard/amex@2x.png 2x, /static/img/creditcard/amex@3x.png 3x" src="/static/img/creditcard/amex.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :disabled="is_sending" v-if="isCreditCardPaymentMethod" class="field is-hidden-tablet card-fields">
              <div class="control">
                <div class="level is-mobile">
                  <div class="level-right is-fullwidth mobile-levels">
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isVisa }]" alt="Visa" srcset="/static/img/creditcard/visa.png, /static/img/creditcard/visa@2x.png 2x, /static/img/creditcard/visa@3x.png 3x" src="/static/img/creditcard/visa.png" />
                    </div>
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isMasterCard }]" alt="Master Card" srcset="/static/img/creditcard/mastercard.png, /static/img/creditcard/mastercard@2x.png 2x, /static/img/creditcard/mastercard@3x.png 3x" src="/static/img/creditcard/mastercard.png" />
                    </div>
                    <div class="level-item">
                      <img :class="[{ 'selected_card' : isAmex }]" alt="American Express" srcset="/static/img/creditcard/amex.png, /static/img/creditcard/amex@2x.png 2x, /static/img/creditcard/amex@3x.png 3x" src="/static/img/creditcard/amex.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h6 class="User-details mar-bot-16">Billing&nbsp;information</h6>
            <div class="field is-grouped is-grouped-multiline">
              <div class="control">
                <label class="label">Registered business name</label>
                <input :disabled="is_sending" autocomplete="cc-csc" v-model="form.registered_business_name" class="input" type="text" placeholder="Registered business name" />
              </div>
              <div class="control">
                <label class="label">Address</label>
                <input :disabled="is_sending" autocomplete="cc-csc" v-model="form.registered_address" class="input" type="text" placeholder="Address" />
              </div>
            </div>
            <div class="field is-grouped is-grouped-multiline">
              <div class="control">
                <label class="label">Registration number (optional)</label>
                <input :disabled="is_sending" autocomplete="cc-csc" v-model="form.registration_number" class="input" type="text" placeholder="Registration number (optional)" />
              </div>
              <div class="control">
                <label class="label">VAT number (optional)</label>
                <input :disabled="is_sending" autocomplete="cc-csc" v-model="form.vat_number" class="input" type="text" placeholder="VAT number (optional)" />
              </div>
            </div>
            <p class="has-text-centered">
              <button @click.prevent="submitForm" :disabled="is_sending || !allRequiredFieldsFilled" :class="['button create-account', { 'is-loading' : is_sending }]" v-html="submitButtonCopy"></button>
            </p>
          </form>
          <div class="flash-msg columns is-mobile is-marginless" v-if="is_payment_error">
            <div class="column is-narrow is-paddingless is-marginless is-centered is-danger has-text-centered">
              <span class="icon is-size-4 is-white">
                <i class="fas fa-ban"></i>
              </span>
            </div>
            <div class="column is-marginless is-paddingless is-hidden-mobile">
              <p>We couldn't process your payment. Please take a moment to review your billing information.</p>
            </div>
            <div class="column is-marginless is-paddingless is-hidden-tablet">
              <p>We couldn't process your payment.</p>
            </div>
          </div>
        </div>
        <!-- EFT THANK YOU -->
        <div v-if="show_thank_you && show_thank_you_eft" class="form-box">
          <p class="has-text-centered bs-head">EFT</p>
          <p class="bs-copy has-text-centered">Please make payment to the following bank account</p>
          <table class="table">
            <tr>
              <td>Bank</td>
              <td>Nedbank</td>
            </tr>
            <tr>
              <td>Account number</td>
              <td>1084&nbsp;211&nbsp;319</td>
            </tr>
            <tr>
              <td>Account name</td>
              <td>TKJ Design (Pty) Ltd T/A hellopeter.com</td>
            </tr>
            <tr>
              <td>Branch</td>
              <td>198765, Business Southern Peninsula</td>
            </tr>
            <tr>
              <td>Your reference</td>
              <td v-text="getPaymentReference"></td>
            </tr>
            <tr>
              <td colspan="2">Send proof of payment to <a href="mailto:accounts@hellopeter.com">accounts@hellopeter.com</a></td>
            </tr>
          </table>
          <p class="has-text-centered"><a :href="getDownloadInvoiceLink">Download invoice</a></p>
          <p class="has-text-centered"><button @click.prevent="goToBilling" class="button ok-button">OK</button></p>
        </div>



      </div>
      <summary-section :purchase-type-is-plan="getPurchaseTypeIsPlan" :want-to-know-more="wantToKnowMore" :invoice-detail="invoiceDetail" :is-billing-section="isBillingSection"></summary-section>
    </div>
    <form class="is-invisible" name="forwardToPurchaseNewBillingGateway" v-if="redirectAction.length > 0 && !showSpinner" method="post" :action="redirectAction" target="_self">
      <p>Please have your phone ready to obtain a One Time Pin</p>
      <input v-for="param in redirectParams" :name="param.name" :value="param.value" :key="param.name" type="hidden" />
      <input type="submit" class="button is-button-blue-outline is-fullwidth" value="Click here to continue" />
    </form>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef */
import axios from 'axios'
import TooltipNew from '../../../widgets/TooltipNew'
import SummarySection from './../../../components/Summary'
import ApiResource from '../../../api/ApiResource'
import CustomDropDown from './../../../components/DropDownBilling'

export default {
  name: 'BillingCheckoutInvoice',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Billing Checkout'
  },
  props: {
    invoiceId: {
      type: String
    }
  },
  components: {
    TooltipNew,
    SummarySection,
    CustomDropDown
  },
  data () {
    return {
      isClickAway: true,
      is_payment_error: false,
      showSpinner: false,
      wantToKnowMore: false,
      purchaseTypeIsPlan: false,
      frequency: 'ANNUAL',
      tier: 'g1',
      tooltipQuestion: true,
      isBillingSection: true,
      invoiceDetail: undefined,
      form: new ApiResource({
        business_id: this.business_id,
        payment_method: 'credit_card',
        selected_cc_number: '',
        selected_cc_name: '',
        selected_cc_month: '',
        selected_cc_year: '',
        selected_cc_ccv: '',
        selected_cc_type: '',
        billing_cycle: 'NONE',
        registered_address: '',
        registered_business_name: '',
        registration_number: '',
        vat_number: '',
        invoice_id: this.invoice,
        tier: this.tier,
        token: '',
        card_return_url: '',
        language: navigator.language,
        screenHeight: screen.height,
        screenWidth: screen.width,
        timezone: new Date().getTimezoneOffset(),
        javaEnabled: navigator.javaEnabled,
        ip: '',
        city: '',
        country: 'ZA',
        postcode: '7800',
        email: localStorage.getItem('email')
      }),
      small_credit_card: true,
      months: [
        {name: '01', value: '01'},
        {name: '02', value: '02'},
        {name: '03', value: '03'},
        {name: '04', value: '04'},
        {name: '05', value: '05'},
        {name: '06', value: '06'},
        {name: '07', value: '07'},
        {name: '08', value: '08'},
        {name: '09', value: '09'},
        {name: '10', value: '10'},
        {name: '11', value: '11'},
        {name: '12', value: '12'}
      ],
      years: [],
      billingAxios: undefined,
      redirectParams: [],
      redirectAction: '',
      is_sending: false,
      show_thank_you: false,
      show_thank_you_eft: false
    }
  },
  created () {
    this.billingAxios = axios.create({
      baseURL: process.env.API_URL
    })

    let locAxios = axios.create({
      baseURL: 'https://ipinfo.io'
    })
    locAxios.get('/json')
      .then(({data}) => {
        if (typeof data.ip !== 'undefined') {
          this.form.ip = data.ip
        }

        if (typeof data.city !== 'undefined') {
          this.form.city = data.city
        }

        if (typeof data.country !== 'undefined') {
          this.form.country = data.country
        }

        if (typeof data.postal !== 'undefined') {
          this.form.post_code = data.postal
        }
      })
  },
  mounted () {
    this.getInvoiceDetails()
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Billing checkout'
    })
    let yr = []
    const currentYear = new Date().getFullYear()
    for (let i = 0; i < 11; i++) {
      const currentValue = (i + currentYear).toString()
      yr.push({name: currentValue, value: currentValue})
    }
    this.years = yr

    if (this.$route.query['id'] !== undefined) {
      this.showCreditCardProcessing()
    }
    const billing = localStorage.getItem('billingDetails')
    if (typeof billing !== 'undefined') {
      const l = JSON.parse(billing)
      this.form.registered_business_name = l.billing_details.registered_name
      this.form.registered_address = l.billing_details.billing_address
      this.form.registration_number = l.billing_details.registration_number
      this.form.vat_number = l.billing_details.vat_number
    }
  },
  methods: {
    goToBilling () {
      this.$router.push('/billing')
    },
    getInvoiceDetails () {
      this.showSpinner = true
      axios.get(`/invoices/${this.invoiceId}/amounts`)
        .then(({data}) => {
          this.invoiceDetail = data
          this.showSpinner = false
          this.form.billing_cycle = this.getBillingCycle
        })
      .catch((error) => {
        console.log('error fetching invoice', error.response.data)
        this.showSpinner = false
      })
    },
    setCreditCardMonth (e) {
      this.form.selected_cc_month = e.value
    },
    setCreditCardYear (e) {
      this.form.selected_cc_year = e.value
    },
    submitForm () {
      this.is_payment_error = false
      this.is_sending = true
      this.form.errors.clear()
      if (this.isCreditCardPaymentMethod) {
        const currentRoute = this.$route.path
        this.form.card_return_url = location.origin + currentRoute
        if (!currentRoute.endsWith('/')) {
          this.form.card_return_url += '/'
        }

        this.form.send(`billing/${this.invoiceId}/credit-card-payment-new`)
        .then((result) => {
          this.is_sending = false
          if (typeof result.paymentResponse !== 'undefined' && typeof result.paymentResponse.redirect !== 'undefined' && typeof result.paymentResponse.redirect.preconditions !== 'undefined') {
            let fields = ''
            result.paymentResponse.redirect.preconditions[0].parameters.forEach((field) => {
              fields += `<input type='hidden' name='${field.name}' value='${field.value}' />`
            })
            const form = `<form action='${result.paymentResponse.redirect.preconditions[0].url}' method='POST'>${fields}</form>`
            const scr = '<scri' + 'pt> window.onload = submitForm; function submitForm() { document.forms[0].submit(); }</scri' + 'pt>'
            const html = `<body>${form}${scr}</body>`
            let iframe = document.createElement('iframe')
            iframe.name = 'peach_submitter'
            iframe.style.display = 'none'
            iframe.src = 'data:text/html;charset=utf-8,' + encodeURI(html)
            document.body.appendChild(iframe)
            setTimeout(() => {
              window.location = result.paymentResponse.redirect.url
            }, 200)
          } else if (typeof result.paymentResponse !== 'undefined' && typeof result.paymentResponse.redirect !== 'undefined' && typeof result.paymentResponse.redirect.parameters !== 'undefined' && result.paymentResponse.redirect.parameters.length > 0) {
            this.redirectParams = result.paymentResponse.redirect.parameters
            this.redirectAction = result.paymentResponse.redirect.url
            setTimeout(() => {
              document.forms['forwardToPurchaseNewBillingGateway'].submit()
            }, 200)
          }
        })
        .catch((error) => {
          this.is_sending = false
          this.is_payment_error = true
          if (typeof error.paymentResponse !== 'undefined' && typeof error.paymentResponse.result !== 'undefined' && error.paymentResponse.result.parameterErrors !== 'undefined') {
            if (error.paymentResponse.result.parameterErrors.length > 0) {
              error.paymentResponse.result.parameterErrors.forEach((data) => {
                if (data.name === 'card.holder') {
                  this.form.errors.errors['selected_cc_name'] = [data.message]
                } else if (data.name === 'card.number') {
                  this.form.errors.errors['selected_cc_number'] = [data.message]
                }
              })
            }
          }
        })
      } else {
        const slug = localStorage.getItem('org_slug')
        this.form.send(`/${slug}/billing-details-eft`)
        .then(() => {
          this.is_sending = false
          this.show_thank_you_eft = true
          this.show_thank_you = true
        })
      }
    },
    showCreditCardProcessing () {
      this.showSpinner = true
      const paymentToken = this.$route.query['id']
      const verifyTokenUrl = `/billing/verify-credit-card-payment/${this.invoiceId}/${paymentToken}`

      axios.get(verifyTokenUrl)
        .then((response) => {
          this.showSpinner = false
          if (response.data.paymentVerification.payment_successful) {
            this.$router.push('/billing')
          } else {
            const errorMessage = response.data.paymentVerification.result.description
            flash(errorMessage, 'is-danger', false)
          }
        })
        .catch(() => {
          console.log('error verifying payment')
          this.showSpinner = false
        })
    }
  },
  computed: {
    getPaymentReference () {
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.invoice !== 'undefined') {
        return this.invoiceDetail.invoice.payment_reference
      }
      return ''
    },
    getDownloadInvoiceLink () {
      if (typeof this.invoiceDetail !== 'undefined' && typeof this.invoiceDetail.invoice !== 'undefined') {
        const apiDomain = process.env.API_URL
        return `${apiDomain}/invoices/${this.invoiceDetail.invoice.id}/file`
      }
      return ''
    },
    isGrowthMonthly () {
      return this.selectedValue < 600
    },
    isGrowthAnnual () {
      return this.selectedValue < 6000 && this.selectedValue > 250
    },
    isPremium () {
      return this.selectedValue > 3000 || isNaN(this.selectedValue)
    },
    getFrequencyCopy () {
      if (typeof this.invoiceDetail !== 'undefined' && this.invoiceDetail.subscriptionType !== 'undefined') {
        let defaultFrequency = 'monthly'
        if (this.invoiceDetail.subscriptionType.is_annually_paid === 1) {
          defaultFrequency = 'annually'
        }
        return `Secured checkout. Billed ${defaultFrequency}. Cancel anytime.`
      }
      return `Secured checkout`
    },
    getBillingCycle () {
      let defaultFrequency = 'MONTHLY'
      if (typeof this.invoiceDetail !== 'undefined' && this.invoiceDetail.subscriptionType !== 'undefined') {
        if (this.invoiceDetail.subscriptionType.is_annually_paid === 1) {
          defaultFrequency = 'ANNUAL'
        }
      }
      return defaultFrequency
    },
    getPurchaseTypeIsPlan () {
      return typeof this.invoiceDetail !== 'undefined' && this.invoiceDetail.invoice.created_for === 'SUBSCRIPTION'
    },
    paymentMethod () {
      return this.form.payment_method === 'credit_card' ? `Credit&nbsp;card` : `EFT`
    },
    isCreditCardPaymentMethod () {
      return this.form.payment_method === 'credit_card'
    },
    submitButtonCopy () {
      return this.form.payment_method === 'credit_card' ? `PAY&nbsp;NOW` : `SUBMIT`
    },
    isAmex () {
      const card = this.form.selected_cc_number.trim()
      return card.length === 15 && (card.startsWith('34') || card.startsWith('37'))
    },
    isVisa () {
      const card = this.form.selected_cc_number.trim()
      return card.startsWith('4') && (card.length === 13 || card.length === 16)
    },
    isMasterCard () {
      const card = this.form.selected_cc_number.trim()
      return card.length === 16 && (card.startsWith('51') || card.startsWith('52') || card.startsWith('53') || card.startsWith('54') || card.startsWith('55'))
    },
    getCardType () {
      const card = this.form.selected_cc_number.trim()
      if (card.length === 15 && (card.startsWith('34') || card.startsWith('37'))) {
        return 'AMEX'
      }
      if (card.length === 16 && (card.startsWith('51') || card.startsWith('52') || card.startsWith('53') || card.startsWith('54') || card.startsWith('55'))) {
        return 'MASTER'
      }
      if (card.startsWith('4') && (card.length === 13 || card.length === 16)) {
        return 'VISA'
      }
      return ''
    },
    allRequiredFieldsFilled () {
      if (this.form.payment_method === 'eft') {
        if (this.form.billing_cycle === 'NONE') {
          return false
        }
        if (this.form.registered_address.trim().length === 0 || this.form.registered_business_name.trim().length === 0) {
          return false
        }
      } else {
        if (this.form.selected_cc_number.trim().length === 0 || this.form.selected_cc_name.trim().length === 0 ||
          this.form.selected_cc_month.trim().length === 0 || this.form.selected_cc_year.trim().length === 0 ||
          this.form.selected_cc_ccv.trim().length === 0 || this.form.selected_cc_type.trim().length === 0 ||
          this.form.billing_cycle === 'NONE' || this.form.registered_address.trim().length === 0 ||
          this.form.registered_business_name.trim().length === 0) {
          return false
        }
      }

      return true
    }
  },
  watch: {
    getCardType (val) {
      this.form.selected_cc_type = ''
      const allowedCards = ['AMEX', 'MASTER', 'VISA']
      if (allowedCards.indexOf(val) !== -1) {
        this.form.selected_cc_type = val
      }
    },
    selectedValue (val) {
      this.frequency = 'ANNUAL'
      if (isNaN(val)) {
        this.tier = 'p4'
      } else {
        if (val < 600) {
          this.frequency = 'MONTHLY'
          Object.entries(this.plans.monthly).forEach((key, _) => {
            if (val === key[1].reviewInvites) {
              this.tier = key[0]
            }
          })
        } else {
          Object.entries(this.plans.annual).forEach((key, _) => {
            if (val === key[1].reviewInvites) {
              this.tier = key[0]
            }
          })
        }
      }
    }
  }
}
</script>
<style scoped>

.bs-copy {
  margin-top: 5px;
  margin-bottom: 40px;
}

.neg-pad {
  margin-top: -2.25rem;
  margin-left: -20px;
  margin-right: -20px;
}

.billing-header {
  margin-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 0;
  border-bottom: solid 1px #dbdbdb;
}

.billing-section {
  margin-left: 16px;
  margin-right: 38px;
  padding: 20px 25px 20px 0;
  border-bottom: solid 1px #dbdbdb;
}

/*.billing-section > .equal-height {*/
/*  display:flex;*/
/*  flex-direction:column;*/
/*  justify-content:space-between;*/
/*}*/

/*.billing-section > .equal-height {*/
/*  margin-top: auto;*/
/*}*/

.billing-section:last-child {
  border: none;
}

.billing-section .bs-head {
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #1261a0;
}

.bs-link, .bs-link:hover, .bs-link:visited {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: right;
  text-decoration: underline;
  color: #30aae1;
}

.billing-section p {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  color: #707070;
}

h1 {
  width: 54px;
  height: 22px;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.about {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

/*.level:not(:last-child) {*/
/*  margin-bottom: 0;*/
/*}*/

.level {
  margin-bottom: 5px;
}

.level:first-child {
  margin-bottom: 13px;
}

.input_credits {
  width: 60px;
  height: 35px;
  border: solid 1px rgba(88, 89, 91, 0.32);
  background-color: #ffffff;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
}

.billing-section > .level.has-input:not(:last-child) {
  margin-bottom: 11px;
}

.billing-section > .level.has-input > .level-right > .level-item:last-child > p {
  width: 75px;
}

.level-left .level-item:not(:last-child), .level-right .level-item:not(:last-child) {
  margin-right: 8px;
}

.billing-section .table {
  border-bottom: solid 1px rgba(88, 89, 91, 0.32)!important;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.billing-section .table > thead > tr > td {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.billing-section .table > tbody > tr > td {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.table td {
  /*border-bottom: solid 1px rgba(219, 219, 219, 0.4)!important;*/
}

.table > tbody > tr {
  background-color: #ffffff !important;
  height: 48px;
  /*margin-bottom: 10px;*/
}

.table {
  margin-top: 35px;
  margin-bottom: 35px;
  padding-bottom: 35px;
  border-bottom: solid 1px rgba(88, 89, 91, 0.32);
}

.table > tr > td:first-child {
  font-weight: bold;
}

.table > tr:last-child > td {
  font-weight: normal;
}

/**
 * MODAL
 */

.modal-content, .modal-card {
  width: auto;
  max-width: 754px;
}

.modal-card-body {
  padding: 0 25px 35px 25px;
  overflow: visible; /* This is to ensure the dropdown menu is not cut off */
}

.modal-card-head {
  border-bottom: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding: 20px 25px 16px 25px;
}

.modal-card-foot {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top: none;

  padding: 0 25px 41px 25px;
}

.modal-card-head, .modal-card-foot {
  background-color: #ffffff;
}

.modal-card-title {
  font-family: 'Open Sans'!important;
  font-size: 14px!important;
  font-weight: bold!important;
  font-stretch: normal!important;
  font-style: normal!important;
  line-height: 1.36!important;
  letter-spacing: normal!important;
  color: #1261a0!important;
}

.modal input[type="text"] {
  width: 341px;
  height: 35px;
  border: solid 1px #dbdbdb;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  padding-left: 15px;
  /*padding-left:18px;*/
}

.modal .delete, .modal .modal-close {
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: #ffffff;
  border: none;
  border-radius: 0;
  cursor: pointer;
  pointer-events: auto;
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 0;
  height: 30px;
  max-height: 30px;
  max-width: 30px;
  min-height: 30px;
  min-width: 30px;
  outline: 0;
  position: relative;
  vertical-align: top;
  width: 30px;
  padding-right: 0;
  padding-left: 0;
}

.modal .delete::before, .modal .modal-close::before {
  height: 2px;
  width: 20px;
}

.modal .delete::after, .modal .modal-close::after {
  height: 20px;
  width: 2px;
}

.modal .delete::after, .modal .delete::before, .modal .modal-close::after, .modal .modal-close::before {
  background-color: #58595b;
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform-origin: center center;
}

.mar-top-10 {
  margin-top: 10px;
}

.cc_field {
  width: 103px!important;
}

.cc_info {
  margin-right: 0!important;
}

.label {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.label:not(:last-child) {
  margin-bottom: 5px;
}

.field.is-grouped>.control:not(:last-child) {
  margin-right: 15px;
}

.button {
  width: 180px;
  height: 35px;
  margin-top: 40px;
  border-radius: 2px!important;
  background-color: #1261a0;
  color: #ffffff;
}

.field.is-grouped.is-grouped-multiline>.control:last-child, .field.is-grouped.is-grouped-multiline>.control:not(:last-child) {
  margin-bottom: 15px;
}

.rel-pos {
  right: 25px;
  top: 8px;
}

.modal .level {
  height: 35px;
  width: 341px;
  padding-left: 140px;
}

.level > .level-right {
  padding-left: 140px;
}

/**
 * END MODAL
 */


.billing-section > .column:first-child {
  padding: 20px 16px!important;
}

.plan-highlights {
  max-width: 828px;
}

.plan-highlights > .column.is-active > p {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: bold;
  color: #30aae1;
  opacity: 1.0;
}

.plan-highlights > .column.is-active > p > span {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.plan-highlights > .column > p {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: bold;
  color: #58595b;
  opacity: 0.4;
}

.plan-highlights > .column > p > span {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  /*opacity: 0.4;*/
}

.plan-highlights > .column:first-child {
  padding-left: 0;
}

.plan-highlights > .column {
  border-right: 1px dashed rgba(88, 89, 91, 0.32);
  height: 100px;
  padding-top: 0;
}

.plan-highlights > .column:last-child {
  border: none;
  padding-right: 0;
}

.plan-highlights + .control {
  margin-top: -45px;
}

.discount {
  font-family: 'Open Sans';
  font-size: 11px!important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #17bd85!important;
}

.card-columns {
  margin-top: 121px;
}

.card-columns > .column {
  max-width: 300px;
  width: 300px;
}

.card-columns > .column:first-child {
  margin-right: 30px;
}

.card-columns > .column > .card {
  border-radius: 5px;
  box-shadow: none;
  border: solid 1px rgba(88, 89, 91, 0.32);
  padding: 20px 5px 20px 25px;
}

.card-columns > .column > .card.is-active {
  border: solid 2px #1261a0;
  box-shadow: 3px 3px 6px 0 rgba(0, 0, 0, 0.16);
}

.card > .header {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #30aae1;
  margin-bottom: 17px;
}

.card > p {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  margin-bottom: 15px;
}

.card > ul > li {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.08;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.card > ul > li:before {
  content: '✓';
  padding-right: 4px;
  color: #30aae1;
}

.card > ul > li.hide:before {
  content: '';
}

.see-features {
  display: block;
  width: 80%;
  margin: 25px 0 0 10px;
  padding-top: 14px;
  border-top: solid 1px rgba(88, 89, 91, 0.32);
}

.see-features > p > a, .see-features > p > a:hover, .see-features > p > a:visited {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: center;
  color: #30aae1;
  text-decoration: underline;
}

.Business-details, .User-details {
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  margin-bottom: 10px;
}

.User-details {
  margin-top: 30px;
}

.input {
  width: 341px;
  height: 35px;
  border: solid 1px #dbdbdb;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  padding-left: 15px;
}



div.outter-ring {
  background-color: #f7fcfe;
  padding: 15px;
  width: 185px;
  z-index: 1;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  padding-top: 19px;
  padding-bottom: 37px;
}

div.inner-ring {
  border-radius: 50%;
  padding: 15px;
  width: 114px;
  z-index: 1;
  margin-left: auto;
  margin-right: auto;
  margin-top: 19px;
  background-color: #edf8fd;
}

.radio {
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.cc_field {
  width: 103px!important;
}

.cc_info {
  margin-right: 0!important;
}

.form-box {
  width: 100%;
  max-width: 697px;
  margin: 0 auto;
}

.help.is-danger {
  color: red!important;
}

.flash-msg {
  margin-top:30px!important;
  border: 1px solid #e8573c;
  height: 68px;
}

.flash-msg > .column:first-child {
  background-color: #e8573c;
  color: #ffffff;
  width: 68px;
  line-height: 68px;
}

.flash-msg > .column:nth-child(2) {
  background-color: #fdf5f4;
  color: #e8573c;
}

.flash-msg > .column:nth-child(2) > p {
  color: #e8573c;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 68px;
  letter-spacing: normal;
  text-align: left;
  padding-left: 20px;
}

@media screen and (max-width: 767px) {
  .billing-header {
    margin-top: 40px;
  }

  h1 {
    font-family: 'Open Sans';
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 25px;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
    padding-left: 20px;
  }

  /*.level.is-mobile .level-item {*/
  /*  margin-right: 20px;*/
  /*}*/

  .level.is-mobile .level-right .level-item {
    margin-right: 0;
  }

  .billing-section {
    margin-left: 36px;
    margin-right: 35px;
    padding-right: 0;
  }

  .bs-link.nothing {
    color: rgba(88, 89, 91, 0.4);
  }

  .mar-top-20 {
    margin-top:20px;
  }

  .billing-header > .level > .level-right > .level-item {
    margin-right:10px;
  }

  .billing-header > .level > .level-right > .level-item:last-child {
    margin-right:20px;
  }

  .form-box {
    padding-left:20px;
    padding-right:20px;
  }

  .User-details {
    margin-top: 20px;
  }

  .level > .level-right {
    padding-left: 0;
  }

  .mobile-levels > .level-item {
    margin-right: 10px!important;
  }

  .button {
    width: 100%;
    margin-top: 10px;
  }

  .card-fields {
    margin-bottom: 40px;
  }

}

.rel-pos {
  right: 14px;
  position: absolute;
  top: 30px;
}


</style>



// WEBPACK FOOTER //
// src/pages/billing/new/BillingCheckout.vue